<template>
  <main>
    <BindAgentToRolesModal
      ref="bindAgentToRolesModal"
      :agent="agentToBind"
      @reset="reset"
      @reload="reload"
    ></BindAgentToRolesModal>

    <Role
      ref="role"
      :roleId="null"
      :sectorId="null"
      :legalSearchId="legalSearchId"
      @update="onRoleCreated"
    />

    <b-modal
      id="confirmRemoveAgentRisk"
      ref="confirmRemoveAgentRisk"
      size="xl"
      header-bg-variant="danger"
      header-text-variant="light"
      title="Confirmar ação?"
      hide-footer
    >
      <section class='modal-font-family w-100'>
        <section>
          <p><strong>A consulta está em modo empresa.</strong></p>
          <p v-if='importedCompany && importedCompany.name'>
            O agente será excluído permanentemente da empresa <strong>{{ importedCompany.name }}</strong>.
          </p>
        </section>

        <section>
          <label>Selecione a opção desejada para essa ação:</label>
        </section>

        <b-container fluid class='w-100 mt-1'>
          <b-row cols="12">
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="6" xl="4">
              <b-overlay :show='loading' rounded opacity='0.6' spinner-small spinner-variant='primary' class='w-100'>
                <b-button variant="danger" @click="deleteSelectedAgents()" class="w-100">
                  Excluir agentes selecionados
                </b-button>
              </b-overlay>
            </b-col>

            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="6" xl="4">
              <b-overlay :show='loadingChangeToFreeMode' rounded opacity='0.6' spinner-small spinner-variant='primary' class='w-100'>
                <b-button variant="danger" @click="changeToFreeMode()" class="w-100">
                  Mudar para modo livre
                </b-button>
              </b-overlay>
            </b-col>

            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="6" xl="4">
              <b-button @click="$bvModal.hide('confirmRemoveAgentRisk')" class="w-100" variant="outline-danger">
                <strong>Cancelar</strong>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </b-modal>

    <b-modal
      id="add-agents-to-role"
      ref="add-agents-to-role"
      header-bg-variant="info"
      header-text-variant="light"
      title="Como deseja prosseguir?"
      size="xl"
    >
      <section class="modal-font-family text-center m-0 p-0">
        <h6><strong>Você pode vincular o agente a um cargo já existente ou cadastrar um novo cargo para associar os agentes selecionados.</strong></h6>
      </section>
      <template #modal-footer>
        <b-container fluid class="w-100 modal-font-family">
          <b-row cols="12">
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-button variant="success" class="w-100 mr-1" @click="chooseAddToExistingRole()">
                Vincular agente a um cargo cadastrado
              </b-button>
            </b-col>
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-button variant="success" class="w-100" @click="chooseRegisterNewRole()">
                Cadastrar cargo
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <table v-if="agents && agents.length > 0" class="text-center w-100" id="physical-risk">
      <thead class='sticky'>
      <tr
        class='w-100 '
        :class="this.risk === 'biologico' ? 'header-risk-biological' : 'header-risk-physical'"
      >
        <th colspan='9' class="w-100">
          <div class='d-flex justify-content-between align-items-center'>
            <strong v-if="this.risk === 'biologico'"  class='m-0 risk-chemical-title'>Riscos Biológicos</strong>
            <strong v-else class='m-0 risk-chemical-title'>Riscos Físicos</strong>
            <div class='d-flex'>
              <button
                type='button'
                class='risk-chemical-toggle'
                @click='togglePhysicalExpanded()'
                :class="showAgents ? '' : 'pulse-global'"
              >
                {{ showAgents ? 'Recolher informações' : 'Expandir informações' }}
              </button>
            </div>
          </div>
        </th>
      </tr>

      <tr
        :class="this.risk === 'biologico' ? 'header-risk-biological' : 'header-risk-physical'"
        class='w-100'
        v-if='showAgents'
      >
        <th colspan="2" class='width-44-percent'>
          CAS: Agente
        </th>
        <th class='width-8-percent p-2'>ACGIH</th>
        <th class='width-8-percent no-wrap p-2'>NR 15</th>
        <th class='width-8-percent p-2'>LINACH</th>
        <th class='width-8-percent p-2'>ESOCIAL - Tabela 24</th>
        <th class='width-8-percent p-2'>DECRETO 3048/99 - Anexo IV</th>
        <th class='width-8-percent p-2'>Ações</th>
      </tr>
      </thead>

      <tbody>
      <template v-for="(item, indexLegalSearche) in agents">
        <tr
          class="tbody-risk-border"
          v-if='showAgents' :key="`${indexLegalSearche}_item_${item.legalSearchId}`"
        >
          <td class='w-40 align-middle'>
            <section class='p-2 risk-role-cell'>
              <div
                v-if='importedCompany && importedCompany._id && item.rolesLegalsearches && item.rolesLegalsearches.length > 0'
                class='d-flex align-items-center justify-content-center'
              >
                <a
                  class='edit-risk-role mr-2'
                  @click="editAgentRoles(item)"
                  title="Editar vínculos de cargo"
                >
                  <b-icon icon="pencil-square" font-scale="1.6"></b-icon>
                </a>

                <a
                  :id="`${item.legalSearchId}_roles_links`"
                  class="add-agent-prouct mb-0"
                >
                  Passe o mouse para exibir os vínculos
                </a>

                <b-popover
                  :target="`${item.legalSearchId}_roles_links`"
                  placement="righttop"
                  triggers="hover focus"
                >
                  <section
                    v-for="(roleLegalsearch, i) in item.rolesLegalsearches"
                    :key="`${roleLegalsearch._id}_${i}`"
                  >
                    <section
                      v-if="roleLegalsearch && roleLegalsearch.role && roleLegalsearch.role.sectorsRoles && roleLegalsearch.role.sectorsRoles.length > 0"
                    >
                      <section
                        class="d-flex align-items-center my-2"
                        v-for="(sectorRole, y) in roleLegalsearch.role.sectorsRoles"
                        :key="`${sectorRole._id}_${y}`"
                      >
                        <svg width="10" height="14" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.16124 0.84313C0.109734 0.795422 0.0694692 0.739302 0.0427424 0.677974C0.0160155 0.616645 0.00335045 0.55131 0.00547096 0.485697C0.00759147 0.420085 0.0244558 0.35548 0.0551008 0.295573C0.0857459 0.235665 0.129571 0.181627 0.184076 0.136544C0.23858 0.0914618 0.302695 0.0562174 0.372761 0.0328233C0.442826 0.00942931 0.517469 -0.0016562 0.592429 0.000199884C0.667389 0.00205597 0.741198 0.0168172 0.80964 0.0436408C0.878083 0.0704645 0.939819 0.108825 0.991324 0.156533L5.84395 4.65389C5.94416 4.74667 6 4.86951 6 4.99719C6 5.12487 5.94416 5.24771 5.84395 5.34049L0.991324 9.83835C0.940159 9.8871 0.878436 9.92647 0.809742 9.95417C0.741048 9.98186 0.666751 9.99733 0.591168 9.99969C0.515584 10.002 0.44022 9.99122 0.369454 9.96786C0.298687 9.9445 0.233928 9.90907 0.178939 9.86362C0.12395 9.81816 0.0798265 9.7636 0.0491315 9.7031C0.0184365 9.6426 0.00178209 9.57736 0.00013535 9.51117C-0.00151138 9.44499 0.0118823 9.37918 0.0395388 9.31756C0.0671954 9.25595 0.108563 9.19976 0.16124 9.15225L4.64392 4.99719L0.16124 0.84313Z" fill="#808080"/>
                        </svg>
                        <p class="mb-0 ml-2 name-sector-role">
                          <span v-if="sectorRole.sector && sectorRole.sector.name"><span>Setor:</span> {{ sectorRole.sector.name }} - </span>
                          <span>Cargo:</span> {{ roleLegalsearch.role.name }}
                        </p>
                      </section>
                    </section>
                  </section>
                </b-popover>
              </div>

              <a
                v-else-if='importedCompany && importedCompany._id'
                class='word-break add-agent-prouct'
                @click="addAgentProduct(item)"
              >
                vincular risco a um cargo
              </a>

              <a
                v-else
                class='word-break '
              >
                -
              </a>
            </section>
          </td>

          <td
            class='w-60 align-middle'
            :style="`${legalSearchSelected.find((x) => x === item.legalSearchId)
                    ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word;`
                    : `word-wrap: break-word`}`"
            :id="`tag_0_${item.legalSearchId}`"
          >

            <b-tooltip
              :target="`${item.legalSearchId}-${item.cas}-${item.index}-searchId`"
              custom-class="custom-tooltip"
              placement="auto"
              triggers="hover"
            >
              <section
                class='p-2'
                v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'
              >
                      <span
                        class='text-white'
                        style='font-size: 15px'
                      >
                        Este agente consta na NR 15 com o seguinte nome:
                        {{ item.attachment11 && item.attachment11.group
                        ? item.attachment11.group
                        : item.nameAttachment11 ? item.nameAttachment11 : '-'
                        }}
                      </span><br /><br />
              </section>

              <section
                class='p-2'
                v-if='item.acgih && item.agent'
              >
                        <span
                          class='text-white'
                          style='font-size: 15px'
                        >
                          Este agente já foi citado na ACGIH com o nome:
                          {{ item.agent ? item.agent : '-' }}
                        </span>
                <br />
                <br />
              </section>

              <a
                :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${item.cas}`"
                target='_blank'
                class='link-pubchem-cas p-2'
              >
                      <span>
                        Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{ item.cas
                        }}
                      </span>
              </a>
            </b-tooltip>

            <a
              href="#" class='hover_links word-break'
              :id="`${item.legalSearchId}-${item.cas}-${item.index}-searchId`"
            >
              <span class='word-break'>{{ model.getsearchId('searchId', item) }}</span>

              <b-icon
                class='ml-1'
                font-scale="1.2"
                icon="info-circle-fill"
                variant="info"
              >
              </b-icon>
            </a>
          </td>

          <td
            :style="`${legalSearchSelected.find((x) => x === item.legalSearchId)
                      ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('acgih')}`
                      : `word-wrap: break-word`}; ${styleWidth('acgih')}`"
            :id="`tag_1_${item.legalSearchId}`"
          >
            <b-tooltip
              :target="`${item.cas}_${item.legalSearchId}_acgih`"
              placement="auto"
              triggers="hover"
            >
                      <span
                        v-if="model.getExist('acgih', item) == 'consta'"
                      >
                        O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('acgih', item) == 'naoConsta'"
              >
                        O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('acgih', item) == 'classificacao'"
              >
                        <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                      </span>

            </b-tooltip>

            <img
              :id="`${item.cas}_${item.legalSearchId}_acgih`"
              width='18'
              height='16'
              v-bind:src="require(`../../../../assets/images/${model.getExist('acgih', item)}.svg`)"
              alt=''
            />
          </td>

          <td
            :style="`${legalSearchSelected.find((x) => x === item.legalSearchId)
                      ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('nr15')}`
                      : `word-wrap: break-word`}; ${styleWidth('nr15')}`"
            :id="`tag_2_${item.legalSearchId}`"
          >
            <b-tooltip
              :target="`${item.cas}_${item.legalSearchId}_nr15`"
              placement="auto"
              triggers="hover"
            >
                      <span
                        v-if="model.getExist('nr15', item) == 'consta'"
                      >
                        O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('nr15', item) == 'naoConsta'"
              >
                        O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('nr15', item) == 'classificacao'"
              >
                        <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                      </span>

            </b-tooltip>

            <img
              :id="`${item.cas}_${item.legalSearchId}_nr15`"
              width='18'
              height='16'
              v-bind:src="require(`../../../../assets/images/${model.getExist('nr15', item)}.svg`)"
              alt=''
            />
          </td>

          <td
            :style="`${legalSearchSelected.find((x) => x === item.legalSearchId)
                      ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('linach')}`
                      : `word-wrap: break-word`}; ${styleWidth('linach')}`"
            :id="`tag_3_${item.legalSearchId}`"
          >
            <b-tooltip
              :target="`${item.cas}_${item.legalSearchId}_linach`"
              placement="auto"
              triggers="hover"
            >
                      <span
                        v-if="model.getExist('linach', item) == 'consta'"
                      >
                        O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('linach', item) == 'naoConsta'"
              >
                        O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('linach', item) == 'classificacao'"
              >
                        <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                      </span>

            </b-tooltip>

            <img
              :id="`${item.cas}_${item.legalSearchId}_linach`"
              width='18'
              height='16'
              v-bind:src="require(`../../../../assets/images/${model.getExist('linach', item)}.svg`)"
              alt=''
            />
          </td>

          <td
            :style="`${legalSearchSelected.find((x) => x === item.legalSearchId)
                      ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('esocial')}`
                      : `word-wrap: break-word`}; ${styleWidth('esocial')}`"
            :id="`tag_4_${item.legalSearchId}`"
          >
            <b-tooltip
              :target="`${item.cas}_${item.legalSearchId}_esocial`"
              placement="auto"
              triggers="hover"
            >
                      <span
                        v-if="model.getExist('esocial', item) == 'consta'"
                      >
                        O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('esocial', item) == 'naoConsta'"
              >
                        O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('esocial', item) == 'classificacao'"
              >
                        <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                      </span>
            </b-tooltip>
            <img
              :id="`${item.cas}_${item.legalSearchId}_esocial`"
              width='18'
              height='16'
              v-bind:src="require(`../../../../assets/images/${model.getExist('esocial', item)}.svg`)"
              alt=''
            />
          </td>

          <td
            :style="`${legalSearchSelected.find((x) => x === item.legalSearchId)
                      ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('decree3048')}`
                      : `word-wrap: break-word`}; ${styleWidth('decree3048')}`"
            :id="`tag_5_${item.legalSearchId}`"
          >
            <b-tooltip
              :target="`${item.cas}_${item.legalSearchId}_decree3048`"
              placement="auto"
              triggers="hover"
            >
                      <span
                        v-if="model.getExist('decree3048', item) == 'consta'"
                      >
                        O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('decree3048', item) == 'naoConsta'"
              >
                        O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                      </span>

              <span
                v-if="model.getExist('decree3048', item) == 'classificacao'"
              >
                        <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                      </span>
            </b-tooltip>

            <img
              :id="`${item.cas}_${item.legalSearchId}_decree3048`"
              width='18'
              height='16'
              v-bind:src="require(`../../../../assets/images/${model.getExist('decree3048', item)}.svg`)"
              alt=''
            />
          </td>

          <td
            :style="`${legalSearchSelected.find((x) => x === item.legalSearchId)
                          ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('actions')}`
                          : `word-wrap: break-word`}; ${styleWidth('actions')}`"
          >
            <img
              style='cursor: pointer'
              class="mr-1 button-remove"
              @click="setRemove(item.legalSearchId)"
              width='24'
              height='24'
              src='../../../../assets/images/lixeira.svg'
              alt=''
            />

          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </main>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import LegalSearchSummary from '@/models/LegalSearchSummary'
import BindAgentToRolesModal from '@/components/LegalSearch/Summary/PhysicalRisk/Modal/BindAgentToRolesModal.vue'
import Role from '@/components/LegalSearch/Gro/components/Role.vue'

export default {
  name: 'AgentsByRisk',
  components: {
    BindAgentToRolesModal,
    Role,
  },
  data() {
    return {
      showAgents: false,
      legalSearchSelected: [],
      agentToBind: null,
      model: LegalSearchSummary,
      legalSearchIdToRemove: null,
      legalSearchId: null,
      loading: false,
      loadingChangeToFreeMode: false,
      userPreferencesId: null,
    }
  },
  props: {
    risk: { type: String, required: false, default: 'fisico' },
  },
  computed: {
    ...mapGetters('legalSearch', {
      legalConsultationAgentsPhysicalRisk: 'legalConsultationAgentsPhysicalRisk',
      legalConsultationAgentsBiologicalRisk: 'legalConsultationAgentsBiologicalRisk',
      lookingForAgents: 'lookingForAgents',
    }),
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
    ...mapGetters('user', {
      user: 'current'
    }),
    ...mapGetters('userPreferences', {
      userPreferences: 'userPreferences',
    }),
    agents() {
      return this.risk === 'biologico'
        ? (this.legalConsultationAgentsBiologicalRisk || [])
        : (this.legalConsultationAgentsPhysicalRisk || [])
    },
  },
  async mounted() {
    await this.loadTabSummaryRiskPreferences()
  },
  watch: {

  },
  methods: {
    ...mapActions('userPreferences', {
      handleUpdateTabSummaryRiskOpen: 'handleUpdateTabSummaryRiskOpen',
      handleGetUserPreferences: 'handleGetUserPreferences'
    }),
    ...mapActions('legalSearch', {
      importFreeModeAgents: 'importFreeModeAgents',
      handleDeletePhysicalBiologicalRiskAgent: 'handleDeletePhysicalBiologicalRiskAgent',
      setLookingForAgents: 'setLookingForAgents',
    }),
    ...mapActions('companyLegalConsultation', {
      handleDeleteAgentCompanyLegalConsultation: 'handleDeleteAgentCompanyLegalConsultation',
      handleUnmarkAllAsLastImportedCompanyLegalConsultation: 'handleUnmarkAllAsLastImportedCompanyLegalConsultation',
      handleGetLastImportedCompanyLegalConsultation: 'handleGetLastImportedCompanyLegalConsultation',
    }),
    reload(){
      this.agentToBind = null
      this.$emit('loadAgentsByRisk')
    },

    reset(){
      this.agentToBind = null
      this.$emit('loadAgentsByRisk')
    },

    async loadTabSummaryRiskPreferences() {
      try {
        await this.handleGetUserPreferences(this.user.id)
        const { tabSummaryBiologicalRiskOpen, tabSummaryPhysicalRiskOpen, _id } = this.userPreferences || {}
        if (!_id) {
          return
        }
        this.userPreferencesId = _id
        this.showAgents = this.risk === 'biologico'
          ? tabSummaryBiologicalRiskOpen
          : tabSummaryPhysicalRiskOpen
      } catch (e) {
        console.error('Erro ao carregar preferências de aba de resumo:', e)
      }
    },

    async togglePhysicalExpanded() {
      try {
        await this.setLookingForAgents(true)
        this.showAgents = !this.showAgents
        if (!this.userPreferencesId) {
          return
        }
        const field = this.risk === 'biologico'
          ? 'tabSummaryBiologicalRiskOpen'
          : 'tabSummaryPhysicalRiskOpen'

        await this.handleUpdateTabSummaryRiskOpen({
          _id: this.userPreferencesId,
          [field]: this.showAgents
        })

      } catch (e) {
        //
      } finally {
        await this.setLookingForAgents(false)
      }
    },

    addAgentProduct(item) {
      const {legalSearchId} = item || {}
      this.legalSearchId = legalSearchId
      this.agentToBind = item || null
      this.$refs['add-agents-to-role'].show()
    },

    editAgentRoles(item) {
      const {legalSearchId} = item || {}
      this.legalSearchId = legalSearchId
      this.agentToBind = item || null
      this.$nextTick(() => this.$refs.bindAgentToRolesModal.show())
    },

    setRemove(legalSearchId) {
      this.legalSearchIdToRemove = legalSearchId
      this.$refs.confirmRemoveAgentRisk.show()
    },

    async deleteSelectedAgents() {
      try {
        this.loading = true
        if (!this.legalSearchIdToRemove) {
          return
        }
        if (this.importedCompany && this.importedCompany._id) {
          await this.handleDeleteAgentCompanyLegalConsultation({
            companyId: this.importedCompany._id,
            legalSearchesId: [this.legalSearchIdToRemove],
          })
        }
        await this.handleDeletePhysicalBiologicalRiskAgent(this.legalSearchIdToRemove)
        this.$emit('loadAgentsByRisk')
        this.$bvModal.hide('confirmRemoveAgentRisk')
        this.legalSearchIdToRemove = null
        this.$bvToast.toast('As informações da empresa foram atualizadas.', {
          title: 'Atenção',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000,
        })
      } catch (e) {
        console.error('Erro ao remover agente:', e)
      } finally {
        this.loading = false
      }
    },

    async changeToFreeMode() {
      try {
        this.loadingChangeToFreeMode = true
        if (this.legalSearchIdToRemove) {
          await this.handleDeletePhysicalBiologicalRiskAgent(this.legalSearchIdToRemove)
        }
        await this.handleUnmarkAllAsLastImportedCompanyLegalConsultation(this.user.id)
        await this.handleGetLastImportedCompanyLegalConsultation(this.user.id)
        await this.importFreeModeAgents(this.user.id)
        this.$emit('loadAgentsByRisk')
        this.legalSearchIdToRemove = null
        this.$bvModal.hide('confirmRemoveAgentRisk')
        this.$bvToast.toast('As informações da empresa foram atualizadas.', {
          title: 'Atenção',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000,
        })
      } catch (e) {
        console.error('Erro ao mudar para modo livre:', e)
      } finally {
        this.loadingChangeToFreeMode = false
      }
    },

    chooseAddToExistingRole() {
      this.$refs['add-agents-to-role'].hide()
      this.$nextTick(() => this.$refs.bindAgentToRolesModal.show())
    },

    chooseRegisterNewRole() {
      this.$refs['add-agents-to-role'].hide()
      this.$refs.role.init()
    },

    async onRoleCreated() {
      this.legalSearchId = null
      this.legalSearchSelected = []
      this.$emit('loadAgentsByRisk')
    },

    styleWidth(field){
      switch (field) {
        case 'searchId':
          return 'max-width : 200px'
        default:
          return 'width : 120px'
      }
    },
  }
}
</script>
<style lang="css" scoped>
main {
  isolation: isolate;
}
#physical-risk {
  border-collapse: separate;
  border-spacing: 0;
}
.width-8-percent {
  width: 8%;
}
.width-44-percent {
  width: 44%;
}

.header-risk-physical th {
  background: #CCE5D2 !important;
  padding: 14px 16px !important;
  border: 1px solid #EDEDED;
}

.header-risk-biological th {
  background: #E3BEB0 !important;
  padding: 14px 16px !important;
  border: 1px solid #EDEDED;
}

.tbody-risk-border td {
  border: 1px solid #EDEDED;
}


.sticky {
  position: sticky;
  top: 10px;
  z-index: 10;
}

.add-agent-prouct {
  color: #04A8F3;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration-line: underline;
  cursor: pointer;
  min-width: 85px;
  font-size: 15px;
}

.risk-role-cell {
  text-align: center;
}

.edit-risk-role {
  display: block;
  text-align: left;
  color: #04A8F3;
  cursor: pointer;
  line-height: 1;
}
</style>

<style lang="css">
.name-sector-role {
  font-weight: 400;
  font-size: 17px;
  color: #000000;
}
</style>
